import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../../services/storage.service';

/**
 * Protects the app routes. A user is considered authenticated when a JWT
 * token exists in localStorage (set at login) OR the old-style app-state
 * flag is still set — both of which persist across browser restarts.
 */
export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const storage = inject(StorageService);
    const router = inject(Router);

    const token = authService.getToken();
    const stateFlag = Boolean(storage.loadAppState()?.isAuthenticated);

    if (token || stateFlag) {
        return true;
    }

    // Redirect to login page
    return router.createUrlTree(['/login']);
};
